/**
 * Static branding for Beltrashow.
 *
 * Mirrors backend `src/common/constants/branding.ts`.
 */
export const BRANDING = {
	id: 2,
	slug: 'beltrashow',
	name: 'Beltrashow',
	logo: 'assets/layout/images/logo.jpeg',
	favicon: 'assets/layout/images/favicon.jpeg',
	loginBackgroundImage: 'assets/layout/images/login-background.jpeg',
	boostBackgroundImage: 'assets/layout/images/boost-background.jpeg',
	splashImage: 'assets/layout/images/splash.png',
	// App icon (monkey on brand blue, same as the PWA icon): sidebar logo
	appIcon: 'assets/icons/192.png',
	// Blue rectangle with the splash wordmark in white: expanded sidebar logo
	sidebarLogo: 'assets/layout/images/logo-sidebar.png',
	// Same wordmark in dark on transparent: next to the logo in the mobile topbar
	topbarWordmark: 'assets/layout/images/logo-wordmark-dark.png',
	// UI blue: one notch deeper than the brand blue (#3B82F6, icon/splash) so white text passes AA
	primaryColor: '#2563EB',
	secondaryColor: '#1D4ED8',
	defaultLanguage: 'es',
	revolutId: 'beltrashow',
	bizumPhone: '638418288',
} as const;

export const FEATURE_FLAGS = {
	landingPage: false,
	paymentCard: true,
	paymentBizum: true,
	paymentRevolut: true,
	referralCode: true,
	subscriptions: true,
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;
